import { oneSecond } from 'src/app/utils/time';

/**
 * Ephemeral Feedback, disappears after some seconds
 */
export class EphemeralFeedback<T extends string = string> {
  private _feedback?: T;
  private timeoutID?: any;
  readonly config = {
    lifespan: 5 * oneSecond,
  };

  /**
   * @param {T | undefined} f
   */
  set feedback(f: T | undefined) {
    if (this.timeoutID) {
      clearTimeout(this.timeoutID);
    }

    this._feedback = f;
    if (f) {
      this.timeoutID = setTimeout(() => {
        this._feedback = undefined;
      }, this.config.lifespan);
    }
  }

  /**
   * gets ephemeral feedback
   */
  get feedback() {
    return this._feedback;
  }
}
